export interface PaymentDisplayGroup<T = any> {
  payment: T
  children: T[]
}

export const sumPaymentGroupAmount = <T extends {amount?: number | string}>(
  payment: T,
  children: T[] = []
) =>
  [payment, ...children].reduce((total, item) => total + Number(item?.amount || 0), 0)

export const sumPaymentGroupWhTaxPrice = <T extends {whTaxPrice?: number | string}>(
  payment: T,
  children: T[] = []
) =>
  [payment, ...children].reduce((total, item) => total + Number(item?.whTaxPrice || 0), 0)

/**
 * Groups only for UI presentation. Do not use this for accounting totals:
 * every payment row, including children, remains a real bank transaction.
 */
export const groupPaymentsForDisplay = <T extends { id?: number; parentPaymentId?: number | null }>(
  payments: T[] = []
): PaymentDisplayGroup<T>[] => {
  const ids = new Set(payments.map((payment) => Number(payment?.id || 0)).filter(Boolean))

  return payments
    .filter(
      (payment) =>
        !payment?.parentPaymentId || !ids.has(Number(payment.parentPaymentId))
    )
    .map((payment) => ({
      payment,
      children: payments.filter(
        (candidate) => Number(candidate?.parentPaymentId || 0) === Number(payment.id)
      ),
    }))
}
